import LPResultsPage from "./LPResultsPage";

export default function LPDataAnalystsResultsPage() {
  return <LPResultsPage lpSlug="data-analysts" lpName="Data Analysts" />;
}
